import { InfoCircleOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';

/**
 * Fatigue management rule guide text.
 */
const FatigueGuide = () => (
  <Collapse>
    <Collapse.Panel
      id="fatigue-management-guidelines-panel"
      key="fatigue-management-guidelines"
      header={
        <>
          <InfoCircleOutlined /> Fatigue Management Guidelines
        </>
      }
      style={{ backgroundColor: '#fffbe6' }}
    >
      <ul>
        <li>
          A maximum of <strong>12-hour</strong> shifts (this is recommended)
        </li>
        <li>
          At least <strong>9</strong> hours complete rest period between shifts
        </li>
        <li>
          Recommended maximum of <strong>5</strong> consecutive day shifts.
          <ul>
            <li>
              24-hour rest period must be provided after five consecutive
              shifts.
            </li>
            <li>
              48-hour rest period must be provided after a further five
              consecutive shifts.
            </li>
          </ul>
        </li>
        <li>
          Recommended maximum of <strong>3</strong> consecutive night shifts or
          shifts for certain high risk roles (e.g. Air Observer).
          <ul>
            <li>
              24-hour rest period must be provided after three consecutive night
              shifts.
            </li>
            <li>
              48-hour rest period must be provided after a further three
              consecutive night shifts.
            </li>
          </ul>
        </li>
      </ul>
    </Collapse.Panel>
  </Collapse>
);

export default FatigueGuide;
